var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseChipEscuro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_658_5766)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#2F5369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14986 2.85535C8.95486 2.66035 8.63986 2.66035 8.44486 2.85535L5.99986 5.29535L3.55486 2.85035C3.35986 2.65535 3.04486 2.65535 2.84986 2.85035C2.65486 3.04535 2.65486 3.36035 2.84986 3.55535L5.29486 6.00035L2.84986 8.44535C2.65486 8.64035 2.65486 8.95535 2.84986 9.15035C3.04486 9.34535 3.35986 9.34535 3.55486 9.15035L5.99986 6.70535L8.44486 9.15035C8.63986 9.34535 8.95486 9.34535 9.14986 9.15035C9.34486 8.95535 9.34486 8.64035 9.14986 8.44535L6.70486 6.00035L9.14986 3.55535C9.33986 3.36535 9.33986 3.04535 9.14986 2.85535Z",
    fill: "#23A0E8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_658_5766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChipEscuro);
export default __webpack_public_path__ + "static/media/close_chip_escuro.5e32a1f529103aeda4cb7e699d48fb3e.svg";
export { ForwardRef as ReactComponent };